import '@css/bestcosme/common.scss'
import '@css/bestcosme/2025_half.scss'

$(document).ready(function () {
  $('.anchor_link').click(function (event) {
    event.preventDefault();
    $('html, body').animate({
      scrollTop: $($.attr(this, 'href')).offset().top
    }, 500, 'swing');
  });

  // main page top slider
  if ($("#banner_owl_carousel").length > 0) {
    let banner_owl = $('#banner_owl_carousel .js_banner_owl_carousel').owlCarousel({
      items: 1,
      loop: true,
      dots: false,
      autoplay: true,
      autoplayTimeout: 4000,
      autoplayHoverPause: true
    });
    $("#banner_owl_carousel .slidesjs-next").click(function () {
      banner_owl.trigger('next.owl.carousel');
    });
    $("#banner_owl_carousel .slidesjs-previous").click(function () {
      banner_owl.trigger('prev.owl.carousel', [300]);
    });
  }

}); 
